import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AuthForm from "../../components/AuthForm";
import { sendRequest } from "../../utils/api";
import { initAllStores } from "../../utils/cache";
import ConfirmModal from "../../Modal/ConfirmModal";
import { getQueryParam, validateSubdomain } from "../../utils/helper-function";
import { setupSocket } from "../../socket";


export function LoginPage() {
  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");

  const [errors, setErrors] = useState({ identifier: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [generalError, setGeneralError] = useState("");
  const [subdomain, setSubdomain] = useState<string | null>(null);
  const [showRegisterModal, setShowRegisterModal] = useState(false);

  //const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const subdomain = validateSubdomain(navigate);
    setSubdomain(subdomain);
  }, [navigate]);



  const handleLogin = async () => {
    // reset errors
    const newErrors = { identifier: "", password: "" };

    if (!identifier) newErrors.identifier = "Username is required";
    if (!password) newErrors.password = "Password is required";

    setErrors(newErrors);
    setGeneralError("");

    const cache = await initAllStores();
    if (!newErrors.identifier && !newErrors.password) {
      setLoading(true);
      setIsDisabled(true);

      try {
        const data = await sendRequest("POST", "/auth/login", {
          identifier,
          password,
          subdomain,
        }, false);


        const { data: { token, user, } } = data;

        // Create Real-Time Socket Connection
        // setupSocket(hotel.hotelId);

        await cache.upsertOne("data", {
          ...user,
          id: "user",
        });

        // Set data in local storage.
        if (token) localStorage.setItem("authToken", token);
        localStorage.setItem("isOnline", "true");
        localStorage.setItem(
          "user", JSON.stringify({
            id: user.userId,
            userName: user.userName,
            role: user.role,
            permissions: user.permissions,
          }));


        const redirect = getQueryParam("redirect");

        if (redirect) {
          const path = redirect.startsWith("/") ? redirect : `/${redirect}`;
          navigate(path);
        } else {
          navigate("/dashboard");
        }

        // fire-and-forget background fetch
        (async () => {
          try {
            const partners = await sendRequest("GET", "/partners");

            await Promise.all([
              cache.clear("partners"),
              cache.saveMany({ partners })
            ]);
            
          } catch (err) {
            console.log("Background fetch error:", err);
          }
        })();

      } catch (err: any) {
        if (err.status === 404) {
          /*
          const proceedToRegistration = window.confirm(
            "The hotel with this subdomain was not found. Would you like to proceed to registration?"
          );

          if (!proceedToRegistration) return;

          window.location.href = "https://wiventory.com/register/";
          */
          setShowRegisterModal(true);

        } else if (err.status === 401 || err.status === 404) {
          setGeneralError("Invalid login credentials.");
        } else if (err.status === 402) {
          navigate("/subscription");
        } else if (err.code == "ERR_NETWORK") {
          setGeneralError("Network error. Please check your internet connection.");
        }

        console.log(err)
      } finally {
        setLoading(false);
        setIsDisabled(false);
      }
    }
  };

  return (
    <>
      <AuthForm
        title="Login to your account"

        inputs={[
          {
            label: "Email or Username",
            type: "text",
            value: identifier,
            onChange: setIdentifier,
            error: errors.identifier,
            placeholder: "Enter email or username",
          },
          {
            label: "Password",
            type: "password",
            value: password,
            onChange: setPassword,
            error: errors.password,
            placeholder: "Enter password",
          },
        ]}

        errorMessage={generalError}
        buttonText="Login"
        disableButton={isDisabled}
        onSubmit={handleLogin}
        loadSpinner={loading}
        extra={
          <p
            className="text-gray-500 text-sm cursor-pointer"
            onClick={() => navigate("/forgot-password")}
          >
            Forgot password?
          </p>
        }
      />

      <ConfirmModal
        isOpen={showRegisterModal}
        title="Hotel Not Found"
        message="The hotel with this subdomain does not exist. Would you like to proceed to registration?"
        onCancel={() => setShowRegisterModal(false)}
        onConfirm={() => (window.location.href = "https://wiventory.com/register/")}
        cancelText="Cancel"
        confirmText="Proceed"
      />

    </>

  );
}